__turbopack_context__.v({
  "detached": "WtM7BG_detached",
  "panel": "WtM7BG_panel",
});
